export const formFieldsStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  padding: '24px',
};

export const infoBoxStyles = {
  padding: '12px 16px',
  borderRadius: '8px',
  backgroundColor: 'action.hover',
};
